import { useState } from "react";

import { DeleteOutlineIcon, EditIcon } from "@dotnet/telematics-design-system";

import { useDialog } from "../../ActionBar/hooks";
import { LICENSE_ACTIONS } from "../../types";
import { TITLES } from "../constants";

const useDesktopLicenseInlineActions = () => {
    const { isOpenDialog, closeDialog, openDialog } = useDialog();

    const [rowData, setRowData] = useState(null);

    const openLicenseDialog = (
        dialogName:
            | LICENSE_ACTIONS.EditDesktopLicense
            | LICENSE_ACTIONS.DeleteDesktopLicense,
        data: any
    ) => {
        setRowData(data);
        openDialog(dialogName);
    };

    const closeLicenseDialog = (
        dialogName:
            | LICENSE_ACTIONS.EditDesktopLicense
            | LICENSE_ACTIONS.DeleteDesktopLicense
    ) => {
        setRowData(null);
        closeDialog(dialogName);
    };

    const inlineActions = [
        {
            title: TITLES.EditDesktopLicense,
            icon: EditIcon,
            clickAction: (data: any) =>
                openLicenseDialog(LICENSE_ACTIONS.EditDesktopLicense, data)
        },
        {
            title: TITLES.DeleteDesktopLicense,
            icon: DeleteOutlineIcon,
            clickAction: (data: any) =>
                openLicenseDialog(LICENSE_ACTIONS.DeleteDesktopLicense, data)
        }
    ];

    return {
        inlineActions,
        rowData,
        isEditOpen: isOpenDialog[LICENSE_ACTIONS.EditDesktopLicense],
        isDeleteOpen: isOpenDialog[LICENSE_ACTIONS.DeleteDesktopLicense],
        closeLicenseDialog
    };
};

export { useDesktopLicenseInlineActions };
